var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGooglePlay = function SvgGooglePlay(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 180 53.332",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play_svg__a",
    x2: 1,
    gradientTransform: "scale(-31.64 31.64)rotate(45 -.903 -.925)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play_svg__b",
    x2: 1,
    gradientTransform: "matrix(-32.255 0 0 32.255 45.098 26.675)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play_svg__c",
    x2: 1,
    gradientTransform: "scale(-42.903 42.903)rotate(45 -1.222 -.585)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play_svg__d",
    x2: 1,
    gradientTransform: "scale(19.156 -19.156)rotate(-44.998 .238 -.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play_svg__e",
    x2: 1,
    gradientTransform: "matrix(-32.255 0 0 32.255 45.098 26.675)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccb300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#cc9700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#cc8400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc7d00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play_svg__f",
    x2: 1,
    gradientTransform: "scale(-42.903 42.903)rotate(45 -1.222 -.585)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cc2e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c0e4e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play_svg__g",
    x2: 1,
    gradientTransform: "scale(-31.64 31.64)rotate(45 -.903 -.925)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#008de0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#008de0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00a7e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00b8e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00c4e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c7e0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play_svg__h",
    x2: 1,
    gradientTransform: "scale(-42.903 42.903)rotate(45 -1.222 -.585)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0333c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ab0f56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play_svg__i",
    x2: 1,
    gradientTransform: "matrix(-32.255 0 0 32.255 45.098 26.675)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0c500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#e0a600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#e09100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e08900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play_svg__j",
    x2: 1,
    gradientTransform: "matrix(-32.255 0 0 32.255 45.098 26.675)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffce40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#ffbc40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb540"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play_svg__k",
    x2: 1,
    gradientTransform: "scale(-31.64 31.64)rotate(45 -.903 -.925)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40b8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#40b9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#40ceff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#40ddff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#40e7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40eaff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play_svg__l",
    x2: 1,
    gradientTransform: "scale(19.156 -19.156)rotate(-44.998 .238 -.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#65b895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#62bd95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#50db97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#44ed98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40f498"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M173.33 53.332H6.67c-3.667 0-6.667-3-6.667-6.667V6.668c0-3.667 3-6.667 6.667-6.667h166.66c3.667 0 6.667 3 6.667 6.667v39.997c0 3.666-3 6.666-6.667 6.666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M101.93 17.465v-5.118l-.044-1.544-.202.074 4.107 6.588h1.28V9.199h-1.295v4.816l.044 1.544.202-.074-3.927-6.286h-1.458v8.266"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#a6a6a6",
    d: "M173.33 0H6.67C3.003 0 .003 3 .003 6.666v40c0 3.666 3 6.666 6.667 6.666h166.66c3.667 0 6.667-3 6.667-6.667V6.668c0-3.667-3-6.667-6.667-6.667m0 1.067c3.088 0 5.6 2.512 5.6 5.6v39.997c0 3.087-2.512 5.6-5.6 5.6H6.67a5.607 5.607 0 0 1-5.6-5.6v-40c0-3.087 2.512-5.6 5.6-5.6h166.66"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M63.356 13.657q0-.303-.058-.628l-.02-.11h-4.121v1.229h3.038v-.134l-.133-.011c-.058.67-.272 1.176-.632 1.537-.573.571-1.276.853-2.14.854-.81 0-1.499-.28-2.092-.85-.587-.568-.88-1.294-.881-2.212.001-.917.294-1.643.881-2.21.593-.571 1.281-.85 2.092-.851.902.002 1.582.3 2.088.901l.094.112.806-.807.086-.087-.079-.093c-.327-.39-.764-.7-1.3-.93a4.3 4.3 0 0 0-1.695-.347c-1.185-.001-2.208.416-3.038 1.24-.833.823-1.252 1.857-1.251 3.072-.001 1.215.418 2.25 1.252 3.073.829.824 1.852 1.24 3.037 1.24 1.234 0 2.258-.41 3.036-1.226l-.003.002c.691-.69 1.034-1.622 1.033-2.764M69.502 9.2h-4.937v8.265h4.937v-1.25h-3.643v-2.27h3.286v-1.227h-3.286v-2.27h3.643m4.335 0h2.234v-1.25h-5.764v1.25h2.235v7.017h1.295m7.239 0V9.199h-1.294v8.266m5.853-7.017h2.235v-1.25h-5.764v1.25h2.234v7.017h1.295m6.652-4.132c0-.903.284-1.627.85-2.203.57-.575 1.252-.858 2.078-.86.825.002 1.509.285 2.078.86.566.576.85 1.3.85 2.203s-.284 1.627-.85 2.202c-.57.576-1.253.858-2.078.86-.826-.002-1.508-.284-2.076-.86s-.852-1.3-.852-2.202m5.957 3.058c.808-.83 1.217-1.86 1.216-3.058 0-1.193-.41-2.22-1.221-3.054-.813-.837-1.83-1.26-3.024-1.259-1.2-.001-2.221.42-3.028 1.254-.81.83-1.217 1.86-1.216 3.059-.001 1.199.406 2.228 1.214 3.06s1.83 1.253 3.03 1.251c1.2.002 2.22-.419 3.029-1.253m-7.387 12.612c-3.136 0-5.693 2.384-5.693 5.67 0 3.266 2.557 5.67 5.693 5.67s5.691-2.405 5.691-5.67c0-3.287-2.555-5.67-5.691-5.67m0 2.232c1.719 0 3.2 1.397 3.2 3.438 0 2.019-1.481 3.435-3.2 3.435-1.718 0-3.201-1.416-3.201-3.435 0-2.041 1.483-3.438 3.201-3.438m-12.422-2.232c-3.136 0-5.693 2.384-5.693 5.67 0 3.266 2.557 5.67 5.693 5.67s5.693-2.405 5.693-5.67c0-3.287-2.557-5.67-5.693-5.67m0 2.232c1.718 0 3.201 1.397 3.201 3.438 0 2.019-1.483 3.435-3.201 3.435-1.719 0-3.2-1.416-3.2-3.435 0-2.041 1.481-3.438 3.2-3.438m-14.772-.494v2.407h5.757c-.172 1.353-.623 2.34-1.31 3.028-.838.838-2.148 1.762-4.447 1.762-3.544 0-6.315-2.857-6.315-6.401s2.771-6.402 6.315-6.402c1.912 0 3.308.752 4.34 1.719l1.696-1.697c-1.439-1.375-3.35-2.427-6.036-2.427-4.854 0-8.935 3.952-8.935 8.807s4.08 8.806 8.935 8.806c2.621 0 4.597-.859 6.143-2.47 1.59-1.59 2.084-3.823 2.084-5.627 0-.56-.043-1.074-.129-1.504zm55.554-1.74c-2.921 0-5.348 2.3-5.348 5.672 0 3.179 2.405 5.67 5.627 5.67 2.6 0 4.105-1.59 4.727-2.514l-1.934-1.287c-.644.946-1.525 1.566-2.793 1.566-1.267 0-2.17-.578-2.75-1.716l7.582-3.137-.256-.645c-.472-1.268-1.912-3.609-4.855-3.609m.086 2.191c.989 0 1.826.495 2.105 1.203l-5.068 2.106c-.065-2.191 1.696-3.309 2.963-3.309m-9.126 8.807h2.493V23.332h-2.492zm-7.15-10.996c-2.835 0-5.434 2.49-5.434 5.691 0 3.18 2.599 5.65 5.434 5.65 1.353 0 2.428-.602 2.986-1.29h.086v.816c0 2.17-1.16 3.33-3.03 3.33-1.524 0-2.47-1.095-2.856-2.02l-2.17.903c.624 1.504 2.278 3.352 5.027 3.352 2.921 0 5.39-1.72 5.39-5.908v-10.18h-2.36v.921h-.087c-.558-.666-1.633-1.265-2.986-1.265m.215 2.232c1.697 0 3.03 1.461 3.03 3.46 0 1.975-1.333 3.414-3.03 3.414-1.72 0-3.158-1.439-3.158-3.415 0-1.997 1.44-3.459 3.158-3.459m26.545-7.904v16.668h2.486v-6.315h3.475c2.758 0 5.469-1.997 5.469-5.177s-2.711-5.176-5.47-5.176zm2.486 2.32h3.54c1.86 0 2.915 1.54 2.915 2.858 0 1.29-1.056 2.855-2.916 2.855h-3.539zm18.914 3.321c-1.8 0-3.667.792-4.44 2.55l2.21.923c.472-.922 1.349-1.223 2.273-1.223 1.286 0 2.594.773 2.615 2.144v.172c-.45-.257-1.414-.642-2.594-.642-2.38 0-4.804 1.308-4.804 3.752 0 2.23 1.951 3.668 4.138 3.668 1.673 0 2.596-.751 3.176-1.631h.084v1.287h2.402v-6.39c0-2.96-2.208-4.61-5.06-4.61m.385 5.938c1.095 0 1.608.236 2.273.558-.193 1.544-1.52 2.639-2.957 2.639l-.002-.002c-.815 0-1.951-.405-1.951-1.414 0-1.286 1.416-1.781 2.637-1.781m13.415-5.575-2.852 7.227h-.085l-2.96-7.227h-2.68l4.438 10.1-2.53 5.619h2.596l6.84-15.719zm-22.4 10.664h2.488V23.331h-2.488z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-play_svg__a)",
    d: "m14.007 43.191-.099-.095c-.388-.41-.617-1.047-.617-1.873v.194V11.93v.203c0-.894.267-1.567.714-1.97l16.516 16.515-16.515 16.515m-.71-31.48v-.004.003m0-.01"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-play_svg__b)",
    d: "m36.025 32.378.126-.071 6.522-3.706c.622-.354 1.036-.782 1.243-1.236-.206.454-.621.883-1.243 1.236l-6.522 3.706zm.002-.195-5.506-5.507 5.505-5.506 6.647 3.776c.844.48 1.318 1.098 1.397 1.73v.002c-.08.63-.553 1.248-1.397 1.728z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-play_svg__c)",
    d: "M15.184 43.819a1.723 1.723 0 0 0 .002 0zm0-.195c-.46 0-.863-.15-1.177-.433l16.515-16.516 5.506 5.507L16.68 43.176c-.536.304-1.043.447-1.494.447m-1.182-.241-.086-.084z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-play_svg__d)",
    d: "M30.52 26.676 14.004 10.16a1.72 1.72 0 0 1 1.177-.433c.452 0 .96.145 1.496.449L36.025 21.17l-5.506 5.506m5.63-5.63L16.677 9.98c-.536-.304-1.044-.448-1.496-.448h-.005.007c.451 0 .959.144 1.494.448z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.313 43.811c.42-.024.883-.168 1.371-.445l19.353-10.995-19.353 10.994c-.487.277-.952.42-1.371.445m-1.301-.43-.004-.004zm-.09-.088-.009-.008q.005.004.009.008"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-play_svg__e)",
    d: "m36.025 32.378.126-.071z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-play_svg__f)",
    d: "M15.185 43.819c-.461 0-.864-.15-1.178-.434l-.005-.003-.086-.084-.008-.008.099-.1c.314.284.716.434 1.177.434.451 0 .958-.144 1.494-.448l19.348-10.994.124.124-.126.072L16.677 43.37c-.488.276-.952.42-1.37.444l-.123.004"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.914 43.285c-.388-.411-.617-1.049-.617-1.874 0 .825.23 1.462.617 1.873"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-play_svg__g)",
    d: "M13.908 43.29c-.388-.41-.617-1.047-.617-1.873v-.194c0 .825.23 1.462.617 1.873l.099.095z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-play_svg__h)",
    d: "m13.908 43.29.099-.1v.001z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-play_svg__i)",
    d: "m36.151 32.307-.124-.124 6.646-3.777c.844-.48 1.318-1.098 1.397-1.728q0 .349-.154.688c-.207.453-.62.882-1.243 1.235z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    d: "M44.083 26.667c0-.698-.467-1.395-1.398-1.924l-6.523-3.707 6.523 3.706c.932.53 1.399 1.228 1.398 1.925"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-play_svg__j)",
    d: "M44.07 26.675c-.08-.632-.553-1.25-1.397-1.73l-6.647-3.775.124-.124 6.523 3.706c.93.529 1.397 1.226 1.397 1.923"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    d: "M13.297 11.917v-.002zm.006-.217v-.003zm0-.006v-.006zm0-.008c.077-1.37.822-2.16 1.876-2.165a1.72 1.72 0 0 0-1.166.433l-.004.003q-.049.045-.095.093c-.35.37-.57.925-.61 1.636"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-play_svg__k)",
    d: "M13.291 12.132v-.204q0-.11.006-.215V11.7c.04-.71.261-1.265.61-1.635l.098.097c-.447.404-.714 1.077-.714 1.97m.712-2.16.003-.004z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    d: "M15.178 9.521h.004z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-play_svg__l)",
    d: "M36.025 21.17 16.677 10.176c-.536-.304-1.044-.448-1.496-.448-.46 0-.863.15-1.177.432l-.097-.097a2 2 0 0 1 .095-.094l.003-.003c.312-.28.71-.43 1.166-.433h.01c.452 0 .96.144 1.496.448l19.472 11.064z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGooglePlay);
export { ForwardRef as Icon };
export default "img/badges/google-play.3b1e23c.svg";